import { atom } from 'recoil';

import { TfaCodeProps } from '../../pages/BatchTicketInvestLink/utils/types';

export const customerOrderIdState = atom({
  key: 'customerOrderIdStateState',
  default: '',
});

export const authorizationTokenState = atom<TfaCodeProps>({
  key: 'authorizationTokenState',
  default: {
    tfaCode: '',
    jwtToken: '',
    expiration: new Date(),
  },
});
